var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0834 46.6667V22.8959L24.5001 30.4792L20.4167 26.2501L35.0001 11.6667L49.5834 26.2501L45.5001 30.4792L37.9167 22.8959V46.6667H32.0834ZM17.5001 58.3334C15.8959 58.3334 14.5231 57.7627 13.3817 56.6213C12.2404 55.4799 11.6687 54.1062 11.6667 52.5001V43.7501H17.5001V52.5001H52.5001V43.7501H58.3334V52.5001C58.3334 54.1042 57.7627 55.478 56.6213 56.6213C55.4799 57.7647 54.1062 58.3354 52.5001 58.3334H17.5001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsUpload);
export default __webpack_public_path__ + "static/media/material-symbols_upload.010252109704443fa4b9e1cc50883098.svg";
export { ForwardRef as ReactComponent };